import { Autocomplete, Chip, TextField } from "@mui/material";

// nomes de itens do Zabbix; texto livre, precisa bater exatamente
export default function ItemNamesInput({
    value = [],
    onChange,
    sugestoes = [],
    disabled = false,
    styles,
}) {
    return (
        <Autocomplete
            multiple
            freeSolo
            fullWidth
            size="small"
            disabled={disabled}
            disableCloseOnSelect
            options={sugestoes}
            value={value}
            onChange={(_event, novo) => {
                const limpos = [];
                for (const item of novo) {
                    const texto = String(item).replace(/\s+/g, " ").trim();
                    if (texto && !limpos.includes(texto)) limpos.push(texto);
                }
                onChange?.(limpos);
            }}
            renderTags={(itens, getTagProps) =>
                itens.map((item, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                        <Chip
                            key={key}
                            size="small"
                            label={item}
                            {...tagProps}
                            sx={{
                                ...styles.chipItem,
                                "& .MuiChip-deleteIcon": {
                                    color: "inherit",
                                    opacity: 0.6,
                                    "&:hover": { opacity: 1 },
                                },
                            }}
                        />
                    );
                })
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    placeholder={value.length === 0 ? "+ adicionar item" : "+ adicionar item"}
                    InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        sx: { fontSize: "0.82rem", gap: 0.5 },
                    }}
                />
            )}
        />
    );
}
